export enum screens {
  home = "home",
  bookingInspection = "booking-inspection",
  progressPhotos = "progressPhotos",
  booking = "booking",
  contactUs = "contactUs",
  backToWebsite = "backToWebsite",
  logout = "logout",
  login = "login",
  selectJob = "selectJob",
  changePassword = "changePassword"
}
